import RegistrerGjest from "./RegistrerGjest";

export default RegistrerGjest;